import React from "react";

import { RemoveActionProvider } from "@main/customers/actions/remove/RemoveActionContext";
import { CreateActionProvider } from "@main/customers/actions/create/CreateActionContext";
import { ListActionProvider } from "@main/customers/actions/list/ListActionContext";
import CustomersPage from "@main/customers/pages/CustomersPage";
import {ResetPasswordActionProvider} from "@main/customers/actions/reset-password-mail/ResetPasswordActionContext";
import {ActiveOrDisableActionProvider} from "@main/customers/actions/active-or-disable-account/ActiveOrDisableActionContext";
import { ChangePasswordActionProvider } from "@main/customers/actions/change-password/ChangePasswordActionContext";


export default function CustomersRouterWrapper(props: { title: string, filters?: any, formDefaultValues?: any, formFilterValues?: any }) {
    const { title, filters, formDefaultValues, formFilterValues } = props;
    return (
      <ListActionProvider>
          <ActiveOrDisableActionProvider>
              <ResetPasswordActionProvider>
                  <ChangePasswordActionProvider>
                      <RemoveActionProvider>
                          <CreateActionProvider>
                              <CustomersPage title={title} filters={filters} formDefaultValues={formDefaultValues} formFilterValues={formFilterValues} />
                          </CreateActionProvider>
                      </RemoveActionProvider>
                  </ChangePasswordActionProvider>
              </ResetPasswordActionProvider>
          </ActiveOrDisableActionProvider>
      </ListActionProvider>
    );
};
